<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Vytvořit poskytovatele"
              @click.prevent="createItem"
          >Vytvořit poskytovatele</a>
        </p>
        <h1 v-translate>Poskytovatelé</h1>
      </div>

      <app-table
              clickable
              deletable
              :data="items"
              :highlight-rows-on-hover="true"
              :order="params.order"
              :page-size="params.limit"
              @sort="sortItems"
              @rowClick="goToDetail"
              @deleteRow="deleteItem"
              :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.search"
                name="search"
                type="search"
                v-model="search"
            />
          </app-table-header-item>
          <app-table-header-item class="field_right">
             <app-table-header-select :label="translations.active">
                <app-select
                    :options="activeSelect"
                    v-model.trim="params.active"
                    @change="fetchItems(true)"
                />
             </app-table-header-select>
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              <div v-html="row.name" />
            </strong>
          </template>
        </app-table-column>
          <app-table-column attribute="importer" :label="translations.importer">
              <template slot-scope="row">
                  {{ importers[row.importer] }}
              </template>
          </app-table-column>
        <app-table-column sortable attribute="active" :label="translations.active">
          <template slot-scope="row">
             <app-graphic-image :value="row.active" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
              :page="listPage"
              :itemsPerPage="params.limit"
              :totalCount="itemsMetadata.totalCount"
              @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import {VUE_APP_BASE_API_URL} from "@/constants/fileConstants";
import axios from "axios";

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Providers',
  detailRouteName: 'vodProvider'
})

export default {
  name: 'currency-items',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin(['Poskytovatelé'])],
  data() {
    return {
      search: '',
      importers: {},
    }
  },
  created() {
    this.search = this.params.search

    this.fetchImporters();
  },
  computed: {
    translations() {
      return {
        importer: this.$gettext('Importer'),
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        active: this.$gettext('Aktivní'),
        created: this.$gettext('Založeno'),
      }
    },
    currentTitle() {
      return [
        this.$gettext('Poskytovatelé')
      ]
    },
    activeSelect() {
      return [
          { name: this.$gettext('Nevybráno'), value: null },
          { name: this.$gettext('Ano'), value: true },
          { name: this.$gettext('Ne'), value: false }
      ]
    },
  },
  methods: {
    fetchImporters() {
      axios.get(VUE_APP_BASE_API_URL + 'providers/importers').then(response => {
          this.importers = response.data;
      });
    },
    shouldRefreshAfterDelete() {
      return true
    }
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.length >= 2) {
          this.params.search = this.search
          this.fetchItems()
      } else if (newVal.length < 2 && oldVal.length >= 2) {
          this.params.search = ''
          this.fetchItems()
      }
    }
  }
}
</script>
